import { useCallback } from "react";
import { Remote } from "../../../../../../core/components/remote/Remote.component";
import {
  PWSSessionBackend,
  RecurlyBillingInfo,
  ZypeSubscription,
  ZypeSubscriptionPlan,
} from "@inferno/renderer-shared-core";
import { axiosLoaderWrapper } from "../../../../lib/coastCommon";
import { getPlanIntervalInMonths } from "../../../../lib/coastUser";
import { CoastAlert } from "../../common/coast-alert/CoastAlert.model";
import { CoastUserSubscriptionsEdit } from "./CoastUserSubscriptionsEdit.component";

interface CoastUserSubscriptionsEditLoaderProps {
  updateSubscription: (s: ZypeSubscription, idx: number) => void;
  setBillingInfo: (billingInfo: RecurlyBillingInfo) => void;
  billingInfo?: RecurlyBillingInfo | null;
  billingInfoError: CoastAlert | null;
  goBack: (v?: CoastAlert[]) => void;
  subscription: ZypeSubscription;
  curSubscriptionIdx: number;
  session: PWSSessionBackend;
}

function isUpgrade(currentSubLengthMonths: number, nextPlan: ZypeSubscriptionPlan) {
  return currentSubLengthMonths < getPlanIntervalInMonths(nextPlan);
}

export const CoastUserSubscriptionsEditLoader = ({
  subscription,
  session,
  ...props
}: CoastUserSubscriptionsEditLoaderProps) => {
  const plansLoader = useCallback(async () => {
    const plans = await session.memberService.listSubscriptionPlans();
    const currentSubLengthMonths = getPlanIntervalInMonths(subscription);
    return plans
      .filter(p => p.third_party_id !== "gift")
      .map(p => ({ ...p, isUpgrade: isUpgrade(currentSubLengthMonths, p) }));
  }, [session.memberService, subscription]);

  return (
    <Remote
      loader={() => axiosLoaderWrapper(plansLoader)}
      cacheKey={`coast-subscription-edit-plans-${subscription.plan_id}`}
      showLoading={true}
    >
      {({ data }) =>
        data ? (
          <CoastUserSubscriptionsEdit
            availablePlansResponse={data}
            subscription={subscription}
            session={session}
            {...props}
          />
        ) : null
      }
    </Remote>
  );
};
